import { getNewsDetailApi } from '@/API/news.js'
import { Message } from 'element-ui'

/**
 * 新闻跳转公共方法
 * @param {Object} newsItem - 新闻项对象
 * @param {String} categoryPath - 分类路径，如 'enterprise', 'industry', 'other'
 * @param {Object} router - Vue Router 实例
 * @returns {Promise<void>}
 */
export async function navigateToNews(newsItem, categoryPath, router) {
  // 数据验证
  if (!newsItem || !newsItem.articleId) {
    console.error('新闻项数据无效:', newsItem)
    Message.error('新闻数据无效')
    return
  }

  // 检查 artType 参数
  if (!Object.prototype.hasOwnProperty.call(newsItem, 'artType')) {
    console.warn('新闻项缺少 artType 参数，使用默认跳转')
    router.push(`/news/detail/${categoryPath}/${newsItem.articleId}`)
    return
  }

  const artType = String(newsItem.artType) // 转换为字符串进行比较

  try {
    switch (artType) {
      case '0':
        // 类型0：富文本，跳转到详情页面
        router.push(`/news/detail/${categoryPath}/${newsItem.articleId}`)
        break

      case '1':
        // 类型1：外链，获取详情后跳转到第三方网址
        await handleExternalLink(newsItem.articleId)
        break

      case '2':
        // 类型2：视频，不做额外操作，直接结束
        break

      default:
        console.warn('未知的新闻类型:', artType)
        Message.warning('未知的新闻类型')
    }
  } catch (error) {
    console.error('处理新闻跳转失败:', error)
    Message.error('操作失败，请稍后重试')
  }
}

/**
 * 处理外链类型新闻
 * @param {Number|String} articleId - 新闻ID
 * @returns {Promise<void>}
 */
async function handleExternalLink(articleId) {
  try {
    const res = await getNewsDetailApi(articleId)
    
    if (res && res.data && res.data.content) {
      const externalUrl = res.data.content
      
      // 打开外部链接
      window.open(externalUrl, '_blank')
    } else {
      console.error('未找到外链地址')
      Message.error('未找到链接地址')
    }
  } catch (error) {
    console.error('获取外链地址失败:', error)
    Message.error('获取链接失败')
  }
}

/**
 * 获取视频详情（仅供视频专区使用）
 * @param {Number|String} articleId - 新闻ID
 * @returns {Promise<Object>} 返回视频详情数据
 */
export async function getVideoDetail(articleId) {
  try {
    const res = await getNewsDetailApi(articleId)
    
    if (res && res.data) {
      return {
        success: true,
        data: res.data
      }
    } else {
      return {
        success: false,
        message: '未找到视频信息'
      }
    }
  } catch (error) {
    console.error('获取视频详情失败:', error)
    return {
      success: false,
      message: '获取视频失败',
      error
    }
  }
}

